import { ResetPasswordForm } from "@/routes/auth/_auth-layout/-components/auth/reset-password.form";
import { FORGOT_PASSWORD_ERROR } from "@/lib/utils";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod/v4";

export const Route = createFileRoute(
  "/auth/_auth-layout/reset-password/$token",
)({
  component: () => <ResetPassword />,
});

function ResetPassword() {
  const params = Route.useParams();
  const navigate = useNavigate();

  const parsed = parseToken(params.token);

  if (isExpired(parsed)) {
    navigate({
      to: `/auth/forgot-password`,
      search: { error: FORGOT_PASSWORD_ERROR.EXPIRED },
    });
  }

  return (
    <div className="flex w-full flex-col  items-center rounded-3xl bg-white text-left gap-5">
      <img
        src="/volume-logo.svg"
        className="self-center"
        width={200}
        height={200}
        alt="Volume logo"
      />
      <h1 className="mt-8 px-8 text-center text-3xl font-extrabold">
        Reset your Password
      </h1>
      <ResetPasswordForm token={parsed.token} />
    </div>
  );
}

const tokenSchema = z.object({
  token: z.string(),
  type: z.string(),
  isUsed: z.boolean(),
  expiresAt: z.string(),
});
type Token = z.infer<typeof tokenSchema>;

function parseToken(token: string): Token {
  // token is a base64 encoded string
  const decoded = atob(token);
  const parsed = JSON.parse(decoded) as Token;
  const validated = tokenSchema.parse(parsed);

  return validated;
}

function isExpired(parsedToken: Token) {
  if (parsedToken.isUsed) {
    return true;
  }
  const date = new Date(parsedToken.expiresAt);
  const now = new Date();
  if (now > date) {
    return true;
  }
  return false;
}
